<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
import { CURRENCY_TOWN_DATA_INDEX } from '../tools'
const [name] = createNamespace('CurrencyTownResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<any>,
      default: () => ({})
    }
  },
  setup(props) {
    const data = toRef(props, 'dataSync')
    return () => (
      <>
        <div class='ant-row-form-item mb-12'>
          在县城规划区范围内购房包干费用=包干货币化安置费用
          <FormItem name={CURRENCY_TOWN_DATA_INDEX.CU_COMP} rules={getRequiredRule('县城规划区/包干货币化安置费用')}>
            <InputRmb v-model:value={data.value[CURRENCY_TOWN_DATA_INDEX.CU_COMP]} style='width: 150px' addonAfter='元/人' />
          </FormItem>
          + 包干奖励补助
          <FormItem name={CURRENCY_TOWN_DATA_INDEX.CU_BONUS} rules={getRequiredRule('县城规划区/包干奖励补助')}>
            <InputRmb v-model:value={data.value[CURRENCY_TOWN_DATA_INDEX.CU_BONUS]} style='width: 150px' addonAfter='元/人' />
          </FormItem>
          （含拆迁奖励及过渡费）
        </div>
        <div class='ant-row-form-item'>
          在乡镇购房包干费用=包干货币化安置费用
          <FormItem name={CURRENCY_TOWN_DATA_INDEX.RT_COMP} rules={getRequiredRule('乡镇/包干货币化安置费用')}>
            <InputRmb v-model:value={data.value[CURRENCY_TOWN_DATA_INDEX.RT_COMP]} style='width: 150px' addonAfter='元/人' />
          </FormItem>
          + 包干奖励补助
          <FormItem name={CURRENCY_TOWN_DATA_INDEX.RT_BONUS} rules={getRequiredRule('乡镇/包干奖励补助')}>
            <InputRmb v-model:value={data.value[CURRENCY_TOWN_DATA_INDEX.RT_BONUS]} style='width: 150px' addonAfter='元/人' />
          </FormItem>
          （含拆迁奖励及过渡费）
        </div>
      </>
    )
  }
})
</script>
